// extracted by mini-css-extract-plugin
export default {"button--indent":"hqPnr","button":"QuE9h","wrapper":"TG3Bh","icon":"qVKSR","wrapper--dark":"TjV2w","wrapper--primary":"LoR0M","wrapper--secondary":"Yw3Vj","menu-button":"zsg6X"};